// Import necessary modules and hooks from React Router and React
import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router";
import { useAuthContext } from "../../../contexts/AuthContext";
import { firstAllowedRoute } from "../../../utils/videowallPermissions";

// Redirect authenticated users to the route determined by their VD tags.
export const PublicRoute = () => {
    const { user, tags, authReady } = useAuthContext();

    const [token, setToken] = useState(null);

    useEffect(() => {
        setToken(localStorage.getItem('unified_videowall_cascais_token'));
    }, [user]);

    // Once auth is ready, redirect based on tags.
    if (authReady && user && token) {
        const destination = firstAllowedRoute(tags);
        if (destination !== '/') {
            return <Navigate to={destination} replace />;
        }
    }

    return <Outlet />;
};